import { axiosInstance } from "../api/axios";
import { toast } from "react-toastify";
import { ApiResponse } from "../models/ApiResponse";
import { ForgotPasswordRequest } from "../models/ForgotPasswordRequest";
import { ResetPasswordRequest } from "../models/ResetPasswordRequest";
import { PasswordComplexity } from "../models/PasswordComplexity";
import { ChangePasswordRequest } from "../models/ChangePasswordRequest";

export const sendForgotPasswordRequest = async (data: ForgotPasswordRequest) => {
  const result = await axiosInstance.post<ApiResponse<ForgotPasswordRequest>>("users/forgotpassword", data);
  if (result.data.statusCode === 200) {
    return true;
  } else {
    toast.error(result.data.status);
  }
  return false;
};

export const resetPasswordRequest = async (data: ResetPasswordRequest) => {
  const result = await axiosInstance.post<ApiResponse<ResetPasswordRequest>>("users/resetpassword", data);
  if (result.data.statusCode === 200) {
    return true;
  } else {
    toast.error(result.data.status);
  }
  return false;
};

export const passwordComplexityRequest = async (token: string): Promise<PasswordComplexity | null> => {
  const result = await axiosInstance.get<ApiResponse<PasswordComplexity>>(
    `security/password/complexity?token=${token}`,
  );
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }
  return null;
};

export const passwordComplexitiesRequest = async () => {
  const result = await axiosInstance.get<ApiResponse<PasswordComplexity[]>>("security/password/complexities");
  if (result.data.statusCode === 200) {
    return result.data.data;
  } else {
    toast.error(result.data.status);
  }
  return null;
};

export const changePasswordRequest = async (userId: number, data: ChangePasswordRequest) => {
  const result = await axiosInstance.post<ApiResponse<ChangePasswordRequest>>(`users/${userId}/changepassword`, data);
  if (result.data.statusCode === 200) {
    return true;
  } else {
    toast.error(result.data.status);
  }
  return result.data.statusCode;
};
